import { getFormattedDateString } from '../../helpers/dateUtils';

export const adminEmailsError = {
  title: 'Error: All Users',
  message: 'Could not retrieve list of system users.',
};

export const projectEntriesError = {
  title: 'Error: Project Entries',
  message: 'Could not retrieve list of system projects linked to user.',
};

export const errorSavingEntry = {
  title: 'Error: Project Entries',
  message: 'There was an error saving your time entry',
}

export const errorSavingEntryHours = {
  title: 'Error: Project Entries',
  message: 'Total hours for the day cannot exceed 15 hours.',
}

export const getSystemsError = {
  title: 'Error: Systems',
  message: 'Could not retrieve list of systems linked to user.',
};

export const getLrProjectsError = {
  title: 'Error: Projects',
  message: 'Could not retrieve available LR projects from server.',
};

export const getLrProceduresError = {
  title: 'Error: Procedures',
  message: 'Could not retrieve available procedures for project from server.',
};

export const addLrProjectError = {
  title: 'Error: Add LR',
  message: 'Could not add specifided project/procedure(s) for user.',
};

export const addVpinProjectError = {
  title: 'Error: Add Project',
  message: 'Could not add specifided project for user.',
};

export const addTimeEntryBulkError = {
  title: 'Error: Bulk Time Entry',
  message: 'Failed to add time entries for the specified project/procedure & date range.',
};

export const getBulkTimeEntryTimeLimitError = (errors) => {
  const dates = errors.map(q => getFormattedDateString(q.date)).join(', ');
  return `You’ve added too many hours (12 max per day) on ${dates}. Please edit these days or change your date range and/or hours for this entry.`;
}